import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack } from '@bingads-webui-react/fabric-control';
import { FixedTitleBar } from './fixed-title-bar';
import { Content } from './content';

export const FixedPanel = (props) => {
  const {
    title, children, id, error, onFocus, noOverflowHidden, relativePosition,
  } = props;

  return (
    <Stack className={`${classNames('collapse-panel', 'collapse-fixed-panel', id)}`} tokens={{ padding: '0 24px' }} onFocus={onFocus}>
      {title && <FixedTitleBar id={id} title={title} isActive error={error} />}
      <Content isActive relativePosition={relativePosition} noOverflowHidden={noOverflowHidden}>{children}</Content>
    </Stack>
  );
};

FixedPanel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  children: PropTypes.node.isRequired,
  onFocus: PropTypes.func,
  error: PropTypes.string,
  noOverflowHidden: PropTypes.bool,
  relativePosition: PropTypes.bool,
};

FixedPanel.defaultProps = {
  id: '',
  error: '',
  title: null,
  onFocus() { },
  noOverflowHidden: false,
  relativePosition: false,
};
